import { FC, useEffect } from 'react';
import { useRouter } from 'next/router';
import { useSubNavigationConfig } from './config';

import NestedMenu from '../NestedMenu';

type SubNavigationProps = {
  nestedMenuVariant?: 'sidebar';
  close: () => void;
};

const SubNavigation: FC<SubNavigationProps> = ({
  nestedMenuVariant,
  close,
}) => {
  const router = useRouter();
  const configItems = useSubNavigationConfig(nestedMenuVariant);

  useEffect(() => {
    router.events.on('routeChangeStart', close);

    return () => {
      router.events.off('routeChangeStart', close);
    };
  }, [router.events, close]);

  return (
    <NestedMenu
      items={configItems}
      translationNamespace={['navbar', 'destination-navigation']}
      variant={nestedMenuVariant}
    />
  );
};

export default SubNavigation;
